import { Form, Select } from "antd";
import { Controller, Control, useFormState } from "react-hook-form";
import "@/entities/journal";
import {
  formatLosSignerLabel,
  getLosSignerOptionKey,
} from "../../../../model/utils/format-los-signer-label";
import { SectionThirdFormType } from "../../model/types";

const { Option } = Select;

interface SectionSignerSelectProps {
  control: Control<SectionThirdFormType>;
  signersList: any[];
  disabled?: boolean;
}

export const SectionSignerSelect = ({
  control,
  signersList,
  disabled = false,
}: SectionSignerSelectProps) => {
  const { errors } = useFormState({
    control,
    name: ["signerId"],
  });
  return (
    <>
      <div className="journal-form-section-title journal-form-section-title--spaced-top">
        Подписант
      </div>

      <Form.Item
        label="Уполномоченный представитель лица, осуществляющего строительство, реконструкцию, кап. ремонт"
        validateStatus={errors.signerId ? "error" : ""}
        help={errors.signerId?.message?.toString()}
      >
        <Controller
          name="signerId"
          control={control}
          rules={{ required: "Выберите представителя" }}
          render={({ field }) => (
            <Select
              {...field}
              placeholder="Выберите представителя"
              allowClear
              showSearch
              optionFilterProp="children"
              disabled={disabled}
            >
              {signersList.map((signer: any) => {
                const label = formatLosSignerLabel(signer);

                return (
                  <Option
                    key={getLosSignerOptionKey(signer)}
                    value={signer.user.userId}
                    label={label}
                  >
                    {label}
                  </Option>
                );
              })}
            </Select>
          )}
        />
        <div className="journal-form-hint">
          Этому человеку будет отправлена данная запись на подписание
        </div>
      </Form.Item>
    </>
  );
};
